import type { AppBrandingDto } from "@/api/types";
import { Api } from "@/api/types";
import { addToHeaders } from "@/helpers/headers";

export const ProjectHeaderName = "X-ProjectId";
export const ContentLanguageHeaderName = "X-Content-Language";

export interface ApiScope {
  projectId?: string;
  token?: string;
  appBranding?: AppBrandingDto;
}

/** Creates an API client for one request scope. Used by ApiClientProvider and by router loaders, which run outside React. */
export function createApiClient(baseUrl: string, { projectId, token, appBranding }: ApiScope = {}): Api<null> {
  return new Api<null>({
    baseUrl,
    customFetch: async (input, init) => {
      init = addToHeaders(init, ProjectHeaderName, projectId);
      init = addToHeaders(init, "Client-Info", appBranding ? `platform=web;appbrand=${appBranding}` : "platform=web");
      init = addToHeaders(init, "Authorization", token ? `Bearer ${token}` : undefined);

      // The generated client throws this response on failure. Keep its request context for error reporting.
      const response = await fetch(input, init);

      return Object.assign(response, { requestMethod: init.method ?? "GET", requestBaseUrl: baseUrl });
    },
  });
}
